import FlyoutNavigation from '@flyout_navigation/flyoutNavigation.ts'

const flyoutNavigation = new FlyoutNavigation(document)
flyoutNavigation.registerEvents()
